import React, { useEffect, useState } from "react";
import "./Attachment.scss";
import { ConfirmationModal } from "../../components/Modals/ConfirmationModal";
import AttachmentList from "./component/AttachmentList/AttachmentList";
import AddUpdateAttachment from "./component/AddUpdateAttachment/AddUpdateAttachment";
const Attachment = ({
  setTab,
  setAttachmentCount,
  setTitle,
  attachmentType,
  TranType,
  AttchType,
  staffId
}) => {
  const [activeTab, setActiveTab] = useState("attachmentList");

  // ************************************************************* Confirmation modal start **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [newAddedAttechment, setNwAddedAttechment] = useState("");
  const [funHandler, setFunHandler] = useState();
  const [attchmentId, setAttchmentId] = useState();
  const [editAttchmentId, setEditAttchmentId] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);

  // ************************************************************* Confirmation modal end **********************************

  switch (activeTab) {
    case "attachmentList":
      return (
        <>
          <AttachmentList
            setActiveTab={setActiveTab}
            setTab={setTab}
            newAddedAttechment={newAddedAttechment}
            setAttachmentCount={setAttachmentCount}
            setAttchmentId={setAttchmentId}
            attchmentId={attchmentId}
            setEditAttchmentId={setEditAttchmentId}
            editAttchmentId={editAttchmentId}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            attachmentType={attachmentType}
            TranType={TranType}
            AttchType={AttchType}
            staffId={staffId}
          />
        </>
      );

    case "addAttachment":
      return (
        <AddUpdateAttachment
          setActiveTab={setActiveTab}
          setNwAddedAttechment={setNwAddedAttechment}
          setAttachmentCount={setAttachmentCount}
          setAttchmentId={setAttchmentId}
          attchmentId={attchmentId}
          editAttchmentId={editAttchmentId}
          setEditAttchmentId={setEditAttchmentId}
          setTitle={setTitle}
          attachmentType={attachmentType}
          TranType={TranType}
          AttchType={AttchType}
          staffId={staffId}
        />
      );

    default:
      return "";
  }
};

export default Attachment;
